export function isRtlLanguage(language) {
  return Boolean(language?.startsWith("ar"));
}
